import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Grid,
  Modal,
  MenuItem,
  FormControl,
  Typography,
  InputLabel,
  Select,
  TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';

import * as CommonActions from '../../../../../store/actions/common.action';
import { getCommonState } from '../../../../../store/selector/common.selector';
import { getHrState } from '../../../../../store/selector/hr.selector';
import { IEditModal, IEditHrInformationModal } from '../../../../interfaces/modal.interface';

const styles = {
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { sm: 600, xs: '100%' },
    bgcolor: 'background.paper',
    borderRadius: { sm: '0.5rem', xs: 0 },
    boxShadow: 24,
    overflowY: 'visible',
    p: 4,
  },

  confirmLogoutFormTitle: { marginBottom: '0.5rem' },

  modalListContainer: {
    marginTop: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    paddingY: '0.5rem',
  },

  modalListItem: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  modalCloseButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '.5rem',
    borderRadius: '2rem',
  },
};

const EditHRInfomartionModal = ({ modalOpen, onClickModal }: IEditModal) => {
  const dispatch = useDispatch();
  /* eslint-disable camelcase */
  const { base_of_assignments } = useSelector(getCommonState);
  const {
    selected: { application },
  } = useSelector(getHrState);

  const [data, setData] = useState<IEditHrInformationModal>({
    /* eslint-disable camelcase */
    email_address: '',
    mobile_no: '',
    base_of_assignment: '',
    last_working_day: '',
  });

  useEffect(() => {
    if (modalOpen) {
      onPatchValueForm();
    }
  }, [application, modalOpen]);

  useEffect(() => {
    dispatch(CommonActions.CommonFetchBaseOfAssignments());
  }, []);

  const onPatchValueForm = () => {
    const { email_address, mobile_no, base_of_assignment, last_working_day } = application;

    setData((prev) => {
      return {
        ...prev,
        email_address,
        mobile_no,
        base_of_assignment,
        last_working_day,
      };
    });
  };

  return (
    <Modal open={modalOpen}>
      <Box sx={styles.modalContainer}>
        <Box>
          <Typography sx={{ fontSize: '1.75rem', mb: '2rem' }} color='primary'>
            Edit Information
          </Typography>

          <Grid container sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid item xs={12} sx={{ mb: '1rem' }}>
              <TextField
                fullWidth
                required
                label='Personal Email Address'
                value={data.email_address}
                onChange={(e) => {
                  setData((p) => ({
                    ...p,
                    email_address: e.target.value,
                  }));
                }}
              />
            </Grid>

            <Grid item xs={12} sx={{ mb: '1rem' }}>
              <TextField
                fullWidth
                label='Mobile Number'
                value={data.mobile_no}
                onChange={(e) => {
                  setData((p) => ({
                    ...p,
                    mobile_no: e.target.value,
                  }));
                }}
              />
            </Grid>

            {base_of_assignments && (
              <Grid item xs={12} sx={{ mb: '1rem' }}>
                <FormControl fullWidth>
                  <InputLabel>Base of Assignment</InputLabel>

                  <Select
                    fullWidth
                    label='Base of Assignment'
                    value={data.base_of_assignment}
                    onChange={(e) => {
                      setData((p) => ({
                        ...p,
                        base_of_assignment: e.target.value,
                      }));
                    }}
                  >
                    {base_of_assignments.items &&
                      base_of_assignments.items.map((e: any) => (
                        <MenuItem key={e} value={e}>
                          {e}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} sx={{ mb: '1rem' }}>
              <DatePicker
                views={['year', 'month', 'day']}
                label='Last Working Day'
                inputFormat={'YYYY-MM-DD'}
                value={data.last_working_day === '' ? null : data.last_working_day}
                onChange={(e) => {
                  const date = moment(e).format('YYYY-MM-DD');
                  setData((p) => ({
                    ...p,
                    last_working_day: date,
                  }));
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={styles.modalCloseButton}>
          <Button
            variant='contained'
            sx={styles.modalCloseButton}
            onClick={() => {
              onClickModal('update', data);
            }}
            disableElevation
          >
            Update
          </Button>

          <Button
            color='inherit'
            variant='contained'
            sx={styles.modalCloseButton}
            onClick={() => {
              onClickModal('cancel');
            }}
            disableElevation
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditHRInfomartionModal;
